import * as React from 'react'
import MUITextField from '@mui/material/TextField'

const TextField = (props) => <MUITextField {...props} />

export default TextField
